import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Button } from './Button';
import { Lock } from 'lucide-react';
export function OfferSection() {
  return <div id="offer-section" className="bg-navy text-cream relative overflow-hidden" data-id="element-126">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-127"></div>

      <SectionWrapper className="pt-24 pb-32" data-id="element-128">
        <div className="max-w-5xl mx-auto" data-id="element-129">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center bg-navy-light/40 p-8 md:p-12 rounded-sm border border-gold/20 shadow-2xl" data-id="element-130">
            <div className="order-2 lg:order-1 flex justify-center" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/8fJCvstGcySDudesDBdwki/heylloyd-image-1777673781625.png" alt="Protocolo de Alerta" className="w-full max-w-sm h-auto object-contain drop-shadow-xl" data-id="element-132" />
            </div>

            <div className="order-1 lg:order-2 space-y-8 text-center lg:text-left" data-id="element-133">
              <h2 className="text-3xl md:text-4xl font-serif text-white leading-tight" data-id="element-134">
                Recupera tu claridad mental y tu descanso{' '}
                <span className="text-gold italic" data-id="element-135">hoy mismo.</span>
              </h2>

              <p className="text-lg font-sans text-cream/80" data-id="element-136">
                El acceso completo al Protocolo de Alerta tiene un valor menor
                al de una semana de cafés que ya no te hacen efecto.
              </p>

              <div className="py-6 border-y border-gold/10" data-id="element-137">
                <p className="text-sm uppercase tracking-widest text-gold mb-2 font-bold" data-id="element-138">
                  Inversión Única
                </p>
                <div className="flex items-baseline justify-center lg:justify-start gap-3" data-id="element-139">
                  <span className="text-2xl md:text-3xl font-serif text-cream/40 line-through" data-id="element-140">
                    $27
                  </span>
                  <span className="text-5xl md:text-6xl font-serif font-bold text-white" data-id="element-141">
                    $6.39
                  </span>
                  <span className="text-cream/50 ml-1 font-sans" data-id="element-142">USD</span>
                </div>
                <div className="mt-3 inline-block bg-gold/20 text-gold px-3 py-1 rounded-full text-sm font-bold tracking-wide" data-id="element-143">
                  76% de descuento
                </div>
              </div>

              <div className="space-y-4" data-id="element-144">
                <Button href="https://vivaclaramente.com/cart/48953528615064:1" className="w-full text-lg py-5 shadow-gold/20" data-id="element-145">
                  Quiero recuperar mis noches y mi carrera
                </Button>
                <div className="flex items-center justify-center lg:justify-start text-cream/50 text-sm font-sans" data-id="element-146">
                  <Lock size={14} className="mr-2" data-id="element-147" />
                  <span data-id="element-148">Acceso inmediato tras la compra. Pago seguro.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}